import React from 'react';

import { useAuth, useEnterprise } from '@fastlessjs/backoffice-layer/dist/hooks';
import { Tag, Typography } from 'antd';

import './extraHeaderInfos.less';

export function ExtraHeaderInfos(): JSX.Element {
  const { user } = useAuth();

  const { data: school } = useEnterprise(
    !user?.hasMultipleScopes && user?.enterpriseId ? user?.enterpriseId : '',
  );

  const roleDisplay =
    ['ADMIN', 'MANAGER'].some((roleElement) => roleElement === user?.group) &&
    user?.group;

  return (
    <div className="extra-header-container">
      <div className="extra-header-info-container">
        <Typography.Text>{user.email}</Typography.Text>
        {roleDisplay && <Tag color="processing">{roleDisplay}</Tag>}
        {school?.enterpriseName && !user.hasMultipleScopes && (
          <Tag color="success">
            <Typography.Text>
              {school?.enterpriseName}
              {user?.enterpriseId && ` (${user?.enterpriseId})`}
            </Typography.Text>
          </Tag>
        )}
      </div>
    </div>
  );
}
